import { useActor } from '@xstate/react';
import { useContext } from 'react';

import {
  DesignStudioServiceContext,
  Mode,
  historyContext,
} from 'src/modules/designStudio/providers';
import { FeatureFlag } from 'src/shared/constants';
import { useMode, useTreatment } from 'src/shared/hooks';
import { isFlagDisabledOrControl } from 'src/shared/telemetry';

export const DESIGN_UPDATES_TO_AUTO_OPEN = 5;

const useShouldAutoOpen = ({
  hasClosedDesignMenu,
  hasBeenOpened,
  openPopover,
  triggerButtonBounce,
}: {
  hasClosedDesignMenu: boolean;
  hasBeenOpened: boolean;
  openPopover: (delay?: number) => void;
  triggerButtonBounce: (delay?: number) => void;
}) => {
  const {
    historyState: { designUpdates },
  } = useContext(historyContext);
  if (
    !hasBeenOpened &&
    (designUpdates === DESIGN_UPDATES_TO_AUTO_OPEN || hasClosedDesignMenu)
  ) {
    triggerButtonBounce(250);
    openPopover(850);
  }
};

const useShouldShowRenderingRequest = (): boolean => {
  const { appService } = useContext(DesignStudioServiceContext);
  const [state] = useActor(appService);
  const { jobId, canRequestRendering, hasRenderings } = state.context;
  const renderingIsEnabled = !isFlagDisabledOrControl(
    useTreatment(FeatureFlag.DesignStudio.HIGH_DEF_RENDERING_CTA),
  );
  const mode = useMode();

  return (
    renderingIsEnabled &&
    mode === Mode.DEFAULT &&
    !!(canRequestRendering || hasRenderings) &&
    !!jobId
  );
};

export { useShouldAutoOpen, useShouldShowRenderingRequest };
